/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  HTTPValidationError,
  PositionPlanSettingsUpdateDTO,
  UpdatePositionPlanSettings200,
} from '../fastAPI.schemas'

/**
 * Store the plan settings of a rip or lintel.

Plan settings do not affect the structural model, so no model event is
raised; the position is replaced in place, as for beams and slabs.
 * @summary Update Position Plan Settings
 */
export const updatePositionPlanSettings = (
  projectGuid: string,
  positionGuid: string,
  positionPlanSettingsUpdateDTO: PositionPlanSettingsUpdateDTO,
) => {
  return customInstance<UpdatePositionPlanSettings200>({
    url: `/projects/${projectGuid}/positions/${positionGuid}/plan-settings`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: positionPlanSettingsUpdateDTO,
  })
}

export const useUpdatePositionPlanSettingsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePositionPlanSettings>>,
    TError,
    { projectGuid: string; positionGuid: string; data: PositionPlanSettingsUpdateDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePositionPlanSettings>>,
  TError,
  { projectGuid: string; positionGuid: string; data: PositionPlanSettingsUpdateDTO },
  TContext
> => {
  const mutationKey = ['updatePositionPlanSettings']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePositionPlanSettings>>,
    { projectGuid: string; positionGuid: string; data: PositionPlanSettingsUpdateDTO }
  > = props => {
    const { projectGuid, positionGuid, data } = props ?? {}

    return updatePositionPlanSettings(projectGuid, positionGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/positions/{positionGuid}/plan-settings` },
    {
      operationId:
        'update_position_plan_settings_projects__project_guid__positions__position_guid__plan_settings_patch',
      operationName: 'updatePositionPlanSettings',
    },
  )

  return customOptions
}

export type UpdatePositionPlanSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePositionPlanSettings>>
>
export type UpdatePositionPlanSettingsMutationBody = PositionPlanSettingsUpdateDTO
export type UpdatePositionPlanSettingsMutationError = HTTPValidationError

/**
 * @summary Update Position Plan Settings
 */
export const useUpdatePositionPlanSettings = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePositionPlanSettings>>,
    TError,
    { projectGuid: string; positionGuid: string; data: PositionPlanSettingsUpdateDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePositionPlanSettings>>,
  TError,
  { projectGuid: string; positionGuid: string; data: PositionPlanSettingsUpdateDTO },
  TContext
> => {
  const mutationOptions = useUpdatePositionPlanSettingsMutationOptions(options)

  return useMutation(mutationOptions)
}
